import CurrencyAmount from '@components/currency-amount/CurrencyAmount';
import { Icon, InfoIconTooltip } from '@components/index';
import { NULLDATE } from '@constants/generic';
import { PaidOnDetails } from '@types';
import { formatISODate } from '@utils/date';

const PaidOnDetailsTooltip = ({
  id,
  paidOnDetails
}: {
  id: string;
  paidOnDetails: PaidOnDetails[];
}) => {
  // find latest date from settlement details
  const latestDate = paidOnDetails.reduce(
    (latest, current) =>
      new Date(current.paid_at) > new Date(latest) ? current.paid_at : latest,
    paidOnDetails[0].paid_at
  );

  return (
    <div className="flex items-center gap-2">
      <div>{formatISODate({ date: latestDate, format: 'dd-mm-yyyy' })}</div>
      <InfoIconTooltip id={`${id}-paidOn`}>
        {[...paidOnDetails].map((item, index) => (
          <div
            className="flex items-center gap-2 text-white"
            key={`${item.paid_at}`}
          >
            <div className="flex flex-col items-start">
              {item.paid_at && item.paid_at !== NULLDATE ? (
                <div className="flex items-center gap-2">
                  <Icon name="settled_on_green" size="24" />
                  <div className="flex flex-col items-start">
                    <div className="flex items-center">
                      <CurrencyAmount
                        value={Number(item.paid_amount)}
                        className="gap-1"
                        symbolClass="font-normal !text-sm"
                        valueClass="font-medium !text-sm"
                      />
                    </div>
                    <div className="flex min-w-max items-center">
                      Paid on{' '}
                      {formatISODate({
                        date: item.paid_at,
                        format: 'dd-mm-yyyy'
                      })}
                    </div>
                  </div>
                </div>
              ) : (
                <div className="my-2 flex items-center gap-2">
                  <Icon name="settled_on_blue" size="24" />
                  <div>
                    <div className="flex items-center">
                      <CurrencyAmount
                        value={Number(item.paid_amount)}
                        className="gap-1"
                        symbolClass="font-normal !text-sm"
                        valueClass="font-medium !text-sm"
                      />
                    </div>
                    <div className="flex min-w-max items-center">
                      Processing
                    </div>
                  </div>
                </div>
              )}
              {index !== paidOnDetails.length - 1 && (
                <div className=" ml-2.5 h-6 w-px border-l border-dashed border-primary" />
              )}
            </div>
          </div>
        ))}
      </InfoIconTooltip>
    </div>
  );
};

export default PaidOnDetailsTooltip;
